export default "__VITE_ASSET__61f36f2f__"